import { h } from 'preact';
import Header from '../Header';
import style from './style.css';
import cx from 'classnames';

const VIDEO_URL = '/assets/playerIndexVideo.mp4';

const HeroImage = () => (
	<div className={cx(style.heroArea, 'flex', 'flex-col')} >
		<Header leadingSlash="" />
		<div className={cx('flex', 'flex-1')}>
			<div className={cx('flex', 'flex-col')}>
				<div className={cx(style.playerText, 'flex-col')}>
					<div className={style.gameChanger}>
						GAME
						<br />
						CHANGER
					</div>
					<div className={style.playerPerformance}>
						The future of sports betting
					</div>
					<button className={style.videoPlayer} onClick={() => Calendly.showPopupWidget(VIDEO_URL)}>
						<div>
							<span>WATCH OUR VIDEO</span>
							<img
								className={style.videoPlayerButton}
								src={'/assets/hero/play_circle.png'}
							/>
						</div>
					</button>
				</div>
				<img
					className={style.animatedScreens}
					src={'/assets/hero/screens_.gif'}
				/>
			</div>

			<img
				className={style.playButton}
				src={'/assets/hero/play_button_centre.png'}
				onClick={() => Calendly.showPopupWidget(VIDEO_URL)}
			/>
			<div
				className={cx(
					style.heroPhone,
					'self-end',
					'items-center',
					'justify-center'
				)}
			>
				{/* <img src={'/assets/hero/testing.gif'} /> */}
			</div>
		</div>
	</div>
);

export default HeroImage;



// WEBPACK FOOTER //
// ./components/Hero/index.jsx